import React from 'react';
type EyebrowProps = {
  children: React.ReactNode;
  className?: string;
};
export function Eyebrow({
  children,
  className = ''
}: EyebrowProps) {
  return <p className={`text-[10px] font-semibold uppercase tracking-eyebrow text-coral ${className}`} data-id="element-207" data-mp="2567j04o5idzm">
      {children}
    </p>;
}